import { Link } from 'react-router-dom';
import SectionHeading from '../../components/SectionHeading';
import CategoryIcon from '../../components/CategoryIcon';
import Loader from '../../components/Loader';
import useFetch from '../../hooks/useFetch';
import { getCategories } from '../../services/api';

const FALLBACK_CATEGORIES = [
  { id: '1', slug: 'grocery', icon: '🛒', name: 'Grocery & Gourmet' },
  { id: '2', slug: 'home', icon: '🏠', name: 'Home & Kitchen' },
  { id: '3', slug: 'toys', icon: '🧸', name: 'Toys & Games' },
  { id: '4', slug: 'beauty', icon: '💄', name: 'Beauty & Care' },
  { id: '5', slug: 'health', icon: '💊', name: 'Health & Wellness' },
  { id: '6', slug: 'personal', icon: '🧴', name: 'Personal Care' },
  { id: '7', slug: 'office', icon: '📦', name: 'Office Supplies' },
  { id: '8', slug: 'pet', icon: '🐾', name: 'Pet Supplies' },
];

function CategoriesSection() {
  const { data, loading, error } = useFetch(() => getCategories(), []);

  if (loading) {
    return (
      <section className="categories-bg" id="categories">
        <div className="section-inner">
          <Loader />
        </div>
      </section>
    );
  }

  const categories =
    Array.isArray(data) && data.length > 0 ? data : error ? FALLBACK_CATEGORIES : FALLBACK_CATEGORIES;

  return (
    <section className="categories-bg" id="categories">
      <div className="section-inner">
        <SectionHeading
          label="Product Catalog"
          title="Wholesale Products Across Every Category"
          sub="We source top-performing SKUs across major Amazon categories with verified brand authorization."
        />
        <div className="cats-grid">
          {categories.map((cat) => (
            <Link
              className="cat-card"
              to={`/products?cat=${cat.slug}`}
              key={cat.id}
            >
              <CategoryIcon
                icon={cat.icon}
                className="cat-icon"
                imgClassName="cat-icon cat-icon-img"
                alt={cat.name}
              />
              <div className="cat-name">{cat.name}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategoriesSection;
